<template>
    <div class="address-detail">
        <van-nav-bar
            title="编辑收货地址"
            left-arrow
            @click-left="$router.back()"
        ></van-nav-bar>
        <van-form class="address-detail-form" @submit="onSubmit">
            <van-field
                v-model="formData.shrMc"
                name="收货人"
                label="收货人"
                placeholder="请输入收货人"
                :rules="[{ required: true, message: '请填写用户名' }]"
            />
            <van-field
                v-model="formData.phone"
                name="手机号码"
                label="手机号码"
                placeholder="请输入手机号码"
                :rules="[
                    { required: true, message: '请填写手机号码' },
                    { pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/, message: '请填写正确的手机号' }
                ]"
            />
            <van-field
                v-model="areaValue"
                name="所在地区"
                label="所在地区"
                placeholder="请选择所在地区"
                is-link
                readonly
                @click="visible = true"
                :rules="[{ required: true, message: '请选择所在地区' }]"
            />
            <van-field
                v-model="formData.detaileAddress"
                rows="2"
                autosize
                label="详细地址"
                type="textarea"
                placeholder="请输入详细地址"
            />
            <van-button
                native-type="submit"
                type="primary" block
                color="#EB5435"
                size="large"
                class="address-detail-btn">保存地址</van-button>
        </van-form>
        <van-popup
            v-model="visible"
            position="bottom"
            safe-area-inset-bottom
        >
            <van-area
                @confirm="areaChange"
                @cancel="areaCancel"
                :area-list="areaList"
                :item-height="itemHeight"
            ></van-area>
        </van-popup>
        <div class="item-height" ref="itemHeight"></div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import areaList from '@/config/area';
export default {
    data() {
        return {
            areaList,
            formData: {
                id: '',
                yezhuBh: '',
                ifDeleted: '',
                ifDefAddress: '',
                shrMc: '',
                phone: '',
                shengBh: '',
                shengMc: '',
                chengshiBh: '',
                chengshiMc: '',
                quxianBh: '',
                quxianMc: '',
                detaileAddress: ''
            },
            visible: false,
            itemHeight: 0
        };
    },
    computed: {
        ...mapState('address', {
            addressDetail: 'addressDetail'
        }),
        areaValue() {
            let arr = [this.formData.shengMc, this.formData.chengshiMc, this.formData.quxianMc];
            arr = arr.filter(item => item);
            return arr.join('/');
        }
    },
    watch: {
        addressDetail: {
            handler() {
                for(let key in this.formData) {
                    this.formData[key] = this.addressDetail[key];
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('address', {
            getAddressDetail: 'getAddressDetailAction',
            addAddress: 'addAddressAction',
            updateAddress: 'updateAddressAction'
        }),
        onSubmit() {
            let params = this.formData;
            for(let key in params) {
                if(!params[key]) {
                    delete params[key];
                }
            }
            if(params.id) {
                this.updateAddress(params).then((res) => {
                    this.$toast(res.msg);
                    this.$router.push('/address');
                }).catch((res) => {
                    this.$toast(res.error);
                });
            }else {
                this.addAddress(params).then((res) => {
                    this.$toast(res.msg);
                    this.$router.push('/address');
                }).catch((res) => {
                    this.$toast(res.error);
                });
            }
        },
        areaChange(data) {
            this.visible = false;
            this.formData.shengBh = data[0].code;
            this.formData.shengMc = data[0].name;
            this.formData.chengshiBh = data[1].code;
            this.formData.chengshiMc = data[1].name;
            this.formData.quxianBh = data[2].code;
            this.formData.quxianMc = data[2].name;
        },
        areaCancel() {
            this.visible = false;
        }
    },
    mounted() {
        this.itemHeight = this.$refs.itemHeight.offsetHeight;
    },
    created() {
        let id = this.$route.query.id;
        if(id) {
            this.getAddressDetail({ id });
        }
    }
};
</script>
<style lang="scss" scoped>
.address-detail {
    .address-detail-form {
        margin-top: 5px;
    }
    .van-nav-bar .van-icon {
        color: #000000;
    }
    .van-nav-bar__title {
        color: #000000;
        font-size: 18px;
        font-weight: bold;
    }
    .van-address-edit {
        padding: 10px 0;
    }
    .address-detail-btn {
        position: fixed;
        bottom: 0;
        left: 0;
        border-radius: 0;
    }
    .item-height {
        height: 44px;
    }
}
</style>